// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-q_ga","advertDetailService__price":"c-q_gb"};